/** Marks where the messages the reader has not seen yet begin. */
export default function UnreadDivider() {
  return (
    <div role="separator" aria-label="New messages" className="caw-unread flex items-center gap-3 py-0.5">
      <span className="h-px flex-1 bg-blue-500/50" />
      <span className="text-[11px] font-medium tracking-wide text-blue-300 uppercase">New</span>
      <span className="h-px flex-1 bg-blue-500/50" />
    </div>
  );
}
